module.exports = __webpack_public_path__ + "static/img/bottom-bg.d58d3b46.png";